<script>
    import { onMount } from "svelte";
    import {
        TitleType,
    } from "../../../../../Utils/utilEnums.svelte";

    import {
        changeToSentenceCase,
        getEmailValidation,
        getPhoneValidation,
        isObjectEmpty,
    } from "../../../../../Utils/utilFunctions.svelte";

    import { apiMethods } from "../../../../../Services/index.svelte";


    import { addErrorInput, removeErrorInput } from "../../../helpers/encounterUtils.svelte";

    import {
        DateInput,
    } from "../../../../../Components/Common/index.svelte";
    import MatchPatientDetails from "../../createEditSections/MatchPatientDetails.svelte";


    export let 
        patientDetails,
        patientContactDetails,
        insuranceDetails,
        workerCompensation,
        workerCompensationObj,
        trafficAuthority,
        trafficAuthorityObj,
        publicInPrivateObj,
        commonDetails,
        insuranceDetailsRef,
        index,
        isFromCreate = false;

    export let isPatientMatched = false;

    $: isValidPhone = patientDetails.phone
          ? getPhoneValidation(patientDetails.phone)
          : true;

    $: isValidEmail = patientDetails.email
          ? getEmailValidation(patientDetails.email)
          : true;

    let matchPatientStatus = 0,
        isMatchingPatientDetails = false,
        matchPatientObj = {};

    let errInputs = [];

    onMount(() => {
        if (isFromCreate) _updateMatchPatientStatus(0);
        else {
            _syncDefaultMatchPatientDetails();
            isPatientMatched = true;
        }
    });

    export const checkValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    const _updateInvalidFieldsStyle = () => {
        // Patient (firstName || middleName || lastName) and DoB are required in order to create encounters
        const patientFirstNameField = document.getElementById(
            `patientFirstNameField-${index}`,
        );
        const patientMiddleNameField = document.getElementById(
            `patientMiddleNameField-${index}`,
        );
        const patientLastNameField = document.getElementById(
            `patientLastNameField-${index}`,
        );

        if (
            !patientFirstNameField.value &&
            !patientMiddleNameField.value &&
            !patientLastNameField.value
        ) {
            errInputs = addErrorInput(
                `patientFirstNameField-${index}`,
                errInputs,
                "First name",
            );
            errInputs = addErrorInput(
                `patientMiddleNameField-${index}`,
                errInputs,
                "Middle name",
            );
            errInputs = addErrorInput(
                `patientLastNameField-${index}`,
                errInputs,
                "Last name",
            );
        } else {
            errInputs = removeErrorInput(`patientFirstNameField-${index}`, errInputs);
            errInputs = removeErrorInput(`patientMiddleNameField-${index}`, errInputs);
            errInputs = removeErrorInput(`patientLastNameField-${index}`, errInputs);
        }

        if (!isValidEmail)
            errInputs = addErrorInput(`patientEmailField-${index}`, errInputs);

        if (!isValidPhone)
            errInputs = addErrorInput(`patientPhoneField-${index}`, errInputs);

        if (!patientDetails.birthDate)
            errInputs = addErrorInput(`patientBirthday-${index}`, errInputs);
    };

    const syncGenderOnTitle = () => {
        const isTitleMale =
            patientDetails.title == 0 || patientDetails.title == 4;
        const isTitleFemale =
            patientDetails.title == 1 ||
            patientDetails.title == 2 ||
            patientDetails.title == 3;

        if (isTitleMale) {
            patientDetails.sex = 0;
            document.getElementById("maleCheck").checked = true;
            document.getElementById("femaleCheck").checked = false;
            document.getElementById("noGenderCheck").checked = false;
        }

        if (isTitleFemale) {
            patientDetails.sex = 1;
            document.getElementById("maleCheck").checked = false;
            document.getElementById("femaleCheck").checked = true;
            document.getElementById("noGenderCheck").checked = false;
        }

        handleMatchPatient();
    };

    const syncTitleOnGender = () => {
        // sex 0 - Male, 1 - Female, 2 - Not specified
        if (patientDetails.title == "Title") {
            if (patientDetails.sex == 0) patientDetails.title = 0;
            else if (patientDetails.sex == 1) patientDetails.title = 2;

            return;
        }

        const isTitleMale =
            patientDetails.title == 0 || patientDetails.title == 4;
        const isTitleFemale =
            patientDetails.title == 1 ||
            patientDetails.title == 2 ||
            patientDetails.title == 3;

        handleMatchPatient();

        switch (patientDetails.sex) {
            case 0: // Male
                if (isTitleFemale) patientDetails.title = 0; // Mr.
                return;
            case 1: // Female
                if (isTitleMale) patientDetails.title = 2; // Ms.
                return;
                // case 2: // Not specified
                //     if (isTitleMale) patientDetails.sex = 0;

                //     if (isTitleFemale) patientDetails.sex = 1;
                return;
            default:
                return;
        }
    };

    let matchingPatientPromise = null;
    export const handleMatchPatient = async (forceMatch = false) => {
        if (isMatchingPatientDetails) return matchingPatientPromise;

        if (!forceMatch && isPatientMatched) return;

        const allRequiredValuesValid =
            patientDetails.firstName &&
            patientDetails.lastName &&
            patientDetails.birthDate;

        if (!allRequiredValuesValid || !commonDetails.selectedDoctor) return; //if doctor not selected do not match

        if (isFromCreate || forceMatch) await matchPatient();
    };

    const matchPatient = async () => {
        isMatchingPatientDetails = true;

        _updateMatchPatientStatus(1);
        matchPatientObj = {};

        const { firstName, middleName, lastName, birthDate, title, sex } =
            patientDetails;

        const pd = {
            firstName,
            middleName,
            lastName,
            birthDate,
            title: title == "Title" ? Number(20) : title,
            // sex, // gender is not required to match patient details
        };

        // match patient details with specified gender
        if (pd.title != 20 && sex != 2) pd.sex = sex;

        matchingPatientPromise = await apiMethods.postMethod
            .matchPatient(pd, commonDetails.selectedDoctor.id)
            .then((res) => {
                if (res.id) matchPatientObj = { ...res };
            });

        isMatchingPatientDetails = false;
        matchingPatientPromise = null;

        if (isObjectEmpty(matchPatientObj)) _updateMatchPatientStatus(3);
        else _updateMatchPatientStatus(2);
    };

    // HELPER FUNCTIONS
    const _syncDefaultMatchPatientDetails = () => {
        const allRequiredValuesValid =
            patientDetails.firstName &&
            patientDetails.lastName &&
            patientDetails.birthDate;

        if (allRequiredValuesValid) _updateMatchPatientStatus(2);
    };

    const _updateMatchPatientStatus = (status = 0) =>
        (matchPatientStatus = status);

</script>

<div class="flex flex-col flex-1 pl-4 pr-4 pt-4 pb-3 w-full gap-4">
    <!-- title, firstName, lastName, toggle alternative name -->
    <div class="flex flex-row gap-2">
        <div class="flex-1">
            <select
                class="select select-bordered select-sm w-full"
                bind:value={patientDetails.title}
                on:change={syncGenderOnTitle}
            >
                <option disabled selected>Title</option>
                {#each TitleType as title}
                    <option value={title.id}>{title.type}</option>
                {/each}
            </select>

        </div>
        <div class="flex-1">
            <input
                type="text"
                id={`patientFirstNameField-${index}`}
                placeholder="First name"
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                bind:value={patientDetails.firstName}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "First name";
                }}
                on:focusout={() => {
                    patientDetails.firstName = changeToSentenceCase(
                        patientDetails.firstName,
                    );
                    handleMatchPatient();
                }}
            />
        </div>
        <div class="flex-1">
            <input
                type="text"
                id={`patientMiddleNameField-${index}`}
                placeholder="Middle name"
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                bind:value={patientDetails.middleName}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "Middle name";
                }}
                on:focusout={() =>
                    (patientDetails.middleName = changeToSentenceCase(
                        patientDetails.middleName,
                    ))}
            />
        </div>
        <div class="flex-1">
            <input
                type="text"
                id={`patientLastNameField-${index}`}
                placeholder="Last name"
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                bind:value={patientDetails.lastName}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "Last name";
                }}
                on:focusout={() => {
                    patientDetails.lastName = changeToSentenceCase(
                        patientDetails.lastName,
                    );
                    handleMatchPatient();
                }}
            />
        </div>
    </div>

    <!-- birth date, gender -->
    <div class="flex flex-row gap-2 items-start">
        <div class="flex-1">
             <DateInput
                placeholder="Date of Birth"
                bind:value={patientDetails.birthDate}
                maxDate={new Date()}
                handleInput={() => handleMatchPatient()}
                id={`patientBirthday-${index}`}
                minDate="1900-01-01"
                showRight
                wrapperClass="input input-sm input-bordered w-full"
                wrapperClassFocus="inputFocus"
            />
        </div>
        <div class="flex-1 flex items-center col-span-2">
            <label class="label cursor-pointer gap-x-2">
                <input
                    type="radio"
                    name="radio-10"
                    class="radio checked:bg-secondary"
                    id="maleCheck"
                    checked={patientDetails.sex == 0}
                    on:change={() => {
                        patientDetails.sex = 0;
                        syncTitleOnGender();
                    }}
                />
                <span>Male</span>
            </label>

            <label class="label cursor-pointer gap-x-2">
                <input
                    type="radio"
                    name="radio-10"
                    class="radio checked:bg-secondary"
                    id="femaleCheck"
                    checked={patientDetails.sex == 1}
                    on:change={() => {
                        patientDetails.sex = 1;
                        syncTitleOnGender();
                    }}
                />
                <span>Female</span>
            </label>

            <label class="label cursor-pointer gap-x-2">
                <input
                    type="radio"
                    name="radio-10"
                    class="radio checked:bg-secondary"
                    id="noGenderCheck"
                    checked={patientDetails.sex == 2}
                    on:change={() => {
                        patientDetails.sex = 2;
                        syncTitleOnGender();
                    }}
                />
                <span>Not specified</span>
            </label>
        </div>
        <div class="flex-1">
            <input
                type="email"
                id={`patientEmailField-${index}`}
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                placeholder="Email"
                bind:value={patientDetails.email}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "Email";
                }}
            />
            {#if !isValidEmail}
                <label class="label">
                    <span class="label-text-alt text-error">
                        Invalid email
                    </span>
                </label>
            {/if}
        </div>
        <div class="flex-1">
            <input
                type="text"
                id={`patientPhoneField-${index}`}
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                placeholder="Phone"
                bind:value={patientDetails.phone}
                on:blur={() =>
                    (patientDetails.phone =
                        patientDetails.phone?.replaceAll(" ", ""))}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "Phone";
                }}
            />
            {#if !isValidPhone && patientDetails.phone}
                <label class="label">
                    <span class="label-text-alt text-error">
                        Invalid phone number
                    </span>
                </label>
            {/if}
        </div>
    </div>
    <MatchPatientDetails
        {matchPatientStatus}
        {isFromCreate}
        bind:matchPatientObj
        bind:isPatientMatched
        bind:patientDetails
        bind:patientContactDetails
        bind:insuranceDetails
        bind:workerCompensation
        bind:workerCompensationObj
        bind:trafficAuthority
        bind:trafficAuthorityObj
        bind:publicInPrivateObj
        {insuranceDetailsRef}
        enableChangeEncounterDoctor={true}
    />
   
</div>

<style>
 
</style>
